import { Button, ButtonProps } from "antd"

const BASE = "rounded-lg text-13 h-10 border-none text-white"

const FILL =
  "bg-primary focus:bg-primary focus:text-white hover:!bg-primary hover:!text-white disabled:!bg-primary disabled:opacity-50 disabled:text-white"

const DANGER_FILL =
  "!bg-[#dc2626] focus:!bg-[#dc2626] focus:!text-white hover:!bg-[#b91c1c] hover:!text-white disabled:!bg-[#dc2626] disabled:opacity-50 disabled:!text-white"

export default function ButtonPrimary(props: ButtonProps) {
  return (
    <Button
      {...props}
      className={`${BASE} ${props.danger ? DANGER_FILL : FILL} ${props.className ?? ""}`}
    />
  )
}
